"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Label_1 = __importDefault(require("../../atoms/typography/Label"));
function SelectBox({ id, label, items, onChange, value, selectClassName }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && react_1.default.createElement(Label_1.default, { id: id, text: label }),
        react_1.default.createElement("select", { id: id, className: selectClassName ||
                'class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-highlight-500 focus:border-highlight-500 sm:text-sm rounded-md dark:bg-black-600 dark:border-black-500 dark:text-gray-300 overflow-ellipsis  border border-gray-300 dark:border-gray-800', onChange: (e) => onChange(e.currentTarget.value), value: value }, items === null || items === void 0 ? void 0 : items.map((tr) => (react_1.default.createElement("option", { key: tr.value, value: tr.value, disabled: tr.disabled }, tr.name || tr.value))))));
}
exports.default = SelectBox;
